import servicioBase from '@/services/servicioBase'

const servicioLogin = {}


servicioLogin.consultarUsuario = (Usuario,Password) => {

    return servicioBase.get('/acceso/consultar/'+ Usuario + ',' + Password).then(respuesta => {return respuesta.data})
    .catch (error => { return error }) 
}


// servicioLogin.obtenerFolio = () => {

//     return servicioBase.get('/acceso/consultar2/').then(respuesta => {return respuesta.data})
//     .catch (error => { return error }) 
// }


export default servicioLogin;